import React from 'react';
var HeaderNotifications = function (props) {
    var path = props.path, count = props.count, target = props.target;
    var rel = target === '_blank' ? 'noopener noreferrer' : undefined;
    return (React.createElement("li", { className: "nav-item b-nav-dropdown dropdown o-header-dropdown notifications" },
        React.createElement("a", { className: "nav-link dropdown-toggle o-header-action-btn notifications-button dropdown-toggle-no-caret", href: path, target: target, rel: rel },
            React.createElement("i", { className: "fal fa-bell notifications-button" }),
            !!count && (React.createElement("p", { className: "notifications-button-number" },
                React.createElement("span", null, count))))));
};
export default React.memo(HeaderNotifications);
